import React, { useState } from "react";
import { Table } from "antd";

const columns = [
  {
    title: "AWB Number",
    dataIndex: "awbNumber",
    key: "awbNumber",
    align: "center",
  },
  {
    title: "Result",
    dataIndex: "reason",
    key: "reason",
    align: "center",
    render: (text) => (
      <span style={{ color: "#ff4d4f", fontWeight: "500" }}>{text}</span>
    ),
  },
];

/**
 * Per-AWB outcome of an X-Ray submit: a totals line plus the failed AWBs.
 * Successes are not listed individually.
 */
const XRayAuditResultTable = ({ summary, failures = [] }) => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);

  if (!summary && !failures.length) {
    return null;
  }

  const rows = failures.map((failure, index) => ({
    key: `f-${failure.awbNumber || index}`,
    awbNumber: failure.awbNumber || "-",
    reason: failure.reason || "Failed",
  }));

  return (
    <div style={{ marginTop: "20px" }}>
      {summary && (
        <div style={{ marginBottom: "8px", fontWeight: 600 }}>
          {summary.successCount || 0} audited
          {summary.failureCount ? ` · ${summary.failureCount} failed` : ""}
        </div>
      )}
      {rows.length > 0 && (
        <Table
          columns={columns}
          dataSource={rows}
          size="small"
          pagination={{
            current: page,
            pageSize,
            total: rows.length,
            showSizeChanger: true,
            pageSizeOptions: ["5", "10", "20", "50"],
            showTotal: (total) => `${total} failed`,
            onChange: (nextPage, nextPageSize) => {
              setPage(nextPage);
              setPageSize(nextPageSize);
            },
          }}
        />
      )}
    </div>
  );
};

export default XRayAuditResultTable;
